(ns bec-cljs-common.components.error-modal
  (:require [reagent.core :as r]
            [re-frame.core :as rf]
            [bec-cljs-common.i18n :as i18n]
            [bec-cljs-common.components.icon :refer [icon]]
            [bec-cljs-common.components.button :refer [button]]
            [bec-cljs-common.components.modal :as modal]))

(defonce variables (r/atom {}))

;; TODO add this to common translations
(def status-code-messages
  {:-1 "Request timed out. Try again later."
   :0 "Check all settings."
   :1xx "Informational"
   :100 "Continue"
   :101 "Switching Protocols"
   :102 "Processing"
   :2xx "Success"
   :200 "OK"
   :201 "Created"
   :202 "Accepted"
   :203 "Non-authoritative Information"
   :204 "No Content"
   :205 "Reset Content"
   :206 "Partial Content"
   :207 "Multi-Status"
   :208 "Already Reported"
   :226 "IM Used"
   :3xx "Redirection"
   :300 "Multiple Choices"
   :301 "Moved Permanently"
   :302 "Found"
   :303 "See Other"
   :304 "Not Modified"
   :305 "Use Proxy"
   :307 "Temporary Redirect"
   :308 "Permanent Redirect"
   :4xx "Client Error"
   :400 "Bad Request."
   :401 "Unauthorized"
   :402 "Payment Required"
   :403 "Forbidden"
   :404 "Not Found"
   :405 "Method Not Allowed"
   :406 "Not Acceptable"
   :407 "Proxy Authentication Required"
   :408 "Request Timeout"
   :409 "Conflict"
   :410 "Gone"
   :411 "Length Required"
   :412 "Precondition Failed"
   :413 "Payload Too Large"
   :414 "Request-URI Too Long"
   :415 "Unsupported Media Type"
   :416 "Requested Range Not Satisfiable"
   :417 "Expectation Failed"
   :418 "I'm a teapot"
   :421 "Misdirected Request"
   :422 "Unprocessable Entity"
   :423 "Locked"
   :424 "Failed Dependency"
   :426 "Upgrade Required"
   :428 "Precondition Required"
   :429 "Too Many Requests"
   :431 "Request Header Fields Too Large"
   :444 "Connection Closed Without Response"
   :451 "Unavailable For Legal Reasons"
   :499 "Client Closed Request"
   :5xx "Server Error"
   :500 "Internal Server Error"
   :501 "Not Implemented"
   :502 "Bad Gateway"
   :503 "Service Unavailable"
   :504 "Gateway Timeout"
   :505 "HTTP Version Not Supported"
   :506 "Variant Also Negotiates"
   :507 "Insufficient Storage"
   :508 "Loop Detected"
   :510 "Not Extended"
   :511 "Network Authentication Required"
   :599 "Network Connect Timeout Error"})

(defn main []
  (let [modal-key :error-modal
        modal-props @(rf/subscribe [:modal modal-key])
        props (:props modal-props)
        custom-message (:message props)
        response (:response modal-props)
        error (or (:error response) (:parse-error response))
        status-code (or (:status response) (:status error))
        status-text (or (:status-text error))
        status-code-type-key (keyword (str (subs (str status-code) 0 1) "xx"))
        status-code-type (when (> (count (str status-code)) 2)
                           (get status-code-messages status-code-type-key))
        request-type (:request-type modal-props)
        modal-class (get {:1xx "is-info"
                          :2xx "is-success"
                          :3xx "is-warning"
                          :4xx "is-warning"
                          :5xx "is-danger"}
                      status-code-type-key)
        emoji-class (get {:2xx "twa twa-partying-face twa-5x"
                          :3xx "twa twa-neutral-face twa-5x"
                          :4xx "twa twa-thinking-face twa-5x"
                          :5xx "twa twa-flushed-face twa-5x"}
                      status-code-type-key)]
    [modal/view
     {:modal-key modal-key
      :modal-props {:style {:z-index "1000"}}
      :background-props {:on-click #(rf/dispatch [:dispatch-many
                                                  [[:dispatch [:cleanup-request request-type]]
                                                   [:dispatch [:close-modal modal-key
                                                               {:on-close-event
                                                                [:reset! variables {}]}]]]])}}
     [modal/header
      {:class modal-class
       :style {:display "flex"
               :justify-content "center"}}
      [:p.title.is-4
       {:style {:color "inherit"
                :text-align "center"}}
       (or status-code-type
         (i18n/get {:fallback-phrase "Something went wrong"} [:something-went-wrong]))]]
     [modal/body
      {:style {:display "flex"
               :align-items "center"
               :flex-direction "column"
               :text-align "center"}}
      (if emoji-class
        [:div
         {:style {:margin-bottom "1rem"}}
         [:i {:class (if (:show-response? @variables)
                       "twa twa-nerd-face twa-5x"
                       emoji-class)}]]
        [icon
         {:class modal-class
          :style {:size "5rem"
                  :margin-bottom "1rem"}}
         [:i.fas.fa-exclamation]])
      (if (string? custom-message)
        [:p.title.is-3
         {:style {:color "inherit"
                  :text-align "center"}}
         (or custom-message
           (if (string? (:error (:response response)))
             (:error (:response response))
             (str status-code " "
               (get status-code-messages (keyword (str status-code))))))]
        custom-message)
      (when-not custom-message
        [:p.subtitle
         status-text])
      [button
       {:class " is-small"
        :style {:margin-bottom "1rem"}
        :on-click #(swap! variables assoc :show-response? (not (:show-response? @variables)))}
       (if (:show-response? @variables)
         "Hide full response"
         "Show full response")]
      [:div.box
       {:style {:display (if (:show-response? @variables)
                           "block"
                           "none")}}
       [:p.subtitle
        (str response)]]
      [button
       {:class " is-primary"
        :style {:min-width "10rem"}
        :on-click #(rf/dispatch [:dispatch-many
                                 [[:dispatch [:cleanup-request request-type]]
                                  [:dispatch [:close-modal modal-key
                                              {:on-close-event [:reset! variables {}]}]]]])}
       (i18n/get {:fallback-phrase "Back"} [:buttons :back])]]]))